import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.6rem;
  margin: 0 0 1rem 0;
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 0.85rem;
  color: ${props => props.theme.colors.textSecondary};
`;
const Switch = styled.div`
  display: inline-flex;
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: ${props => props.theme.borderRadius};
  overflow: hidden;
  background-color: ${props => props.theme.colors.surface};
`;
const Option = styled.button`
  font-family: inherit;
  font-size: 0.85rem;
  font-weight: 600;
  border: none;
  padding: 0.45rem 0.9rem;
  min-height: 36px;
  cursor: pointer;
  background-color: ${props => (props.$active ? props.theme.colors.primary : 'transparent')};
  color: ${props => (props.$active ? props.theme.colors.textPrimary : props.theme.colors.secondary)};
`;

/**
 * Selector "Mis clientes / Toda la casa" de las planillas del comercial. Es un
 * filtro de vista: "Mis clientes" son sus cuentas del SGC más lo que cargó él.
 */
const MisClientesToggle = ({ activo, onChange, cantidadCuentas }) => (
    <Wrapper>
        <span>Ver:</span>
        <Switch role="tablist" aria-label="Alcance de la planilla">
            <Option type="button" role="tab" aria-selected={activo} $active={activo} onClick={() => onChange(true)}>
                Mis clientes
            </Option>
            <Option type="button" role="tab" aria-selected={!activo} $active={!activo} onClick={() => onChange(false)}>
                Toda la casa
            </Option>
        </Switch>
        {activo && (
            <span>
                {cantidadCuentas === 1 ? '1 cuenta asignada' : `${cantidadCuentas} cuentas asignadas`} en el SGC, más lo que cargaste vos.
            </span>
        )}
    </Wrapper>
);

export default MisClientesToggle;
